var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSampleDocumentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 208,
    viewBox: "0 0 150 208",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddd_745_14612)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 6C3 3.79086 4.79086 2 7 2H103.384C104.444 2 105.461 2.42096 106.211 3.17037L126.02 22.9623L145.827 42.7528C146.578 43.503 147 44.5209 147 45.5824V200C147 202.209 145.209 204 143 204H7C4.79086 204 3 202.209 3 200V6Z",
    fill: "url(#paint0_linear_745_14612)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147 43.9245H106.004C105.471 43.9245 105.04 43.4979 105.04 42.9717V2L147 43.9245Z",
    fill: "url(#paint1_linear_745_14612)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.2583,
    y: 61.0754,
    width: 113.483,
    height: 8.57547,
    fill: "url(#paint2_linear_745_14612)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.2583,
    y: 35.3491,
    width: 40.053,
    height: 8.57547,
    fill: "url(#paint3_linear_745_14612)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.2583,
    y: 79.1792,
    width: 113.483,
    height: 8.57547,
    fill: "url(#paint4_linear_745_14612)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.2583,
    y: 97.283,
    width: 113.483,
    height: 8.57547,
    fill: "url(#paint5_linear_745_14612)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.2583,
    y: 115.387,
    width: 41.9603,
    height: 8.57548,
    fill: "url(#paint6_linear_745_14612)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddd_745_14612",
    x: 0,
    y: 0,
    width: 150,
    height: 208,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0588235 0 0 0 0 0.0901961 0 0 0 0 0.164706 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_745_14612"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0588235 0 0 0 0 0.0901961 0 0 0 0 0.164706 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_745_14612",
    result: "effect2_dropShadow_745_14612"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0588235 0 0 0 0 0.0901961 0 0 0 0 0.164706 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_745_14612",
    result: "effect3_dropShadow_745_14612"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_745_14612",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_745_14612",
    x1: 5.38411,
    y1: 6.28774,
    x2: 144.934,
    y2: 204.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0214689,
    stopColor: "#F4F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_745_14612",
    x1: 107.424,
    y1: 42.0189,
    x2: 144.139,
    y2: 42.4961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E7F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E7F2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_745_14612",
    x1: 18.2583,
    y1: 65.8396,
    x2: 138.894,
    y2: 65.8396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3DDEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3DDEE",
    stopOpacity: 0.21
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_745_14612",
    x1: 18.2583,
    y1: 40.1133,
    x2: 60.8356,
    y2: 40.1133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3DDEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3DDEE",
    stopOpacity: 0.21
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_745_14612",
    x1: 18.2583,
    y1: 83.9434,
    x2: 138.894,
    y2: 83.9434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3DDEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3DDEE",
    stopOpacity: 0.21
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_745_14612",
    x1: 18.2583,
    y1: 102.047,
    x2: 138.894,
    y2: 102.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3DDEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3DDEE",
    stopOpacity: 0.21
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_745_14612",
    x1: 18.2583,
    y1: 120.151,
    x2: 62.8631,
    y2: 120.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3DDEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3DDEE",
    stopOpacity: 0.21
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSampleDocumentIcon);
export default __webpack_public_path__ + "static/media/SampleDocumentIcon.44d9b742.svg";
export { ForwardRef as ReactComponent };